export const AUTHENTICATION_TIMEOUT_MS = 15_000;

export class AuthenticationTimeoutError extends Error {
  constructor(timeoutMs: number) {
    super(`Authentication did not complete within ${timeoutMs}ms.`);
    this.name = "AuthenticationTimeoutError";
  }
}

export const withAuthenticationTimeout = <T>(
  operation: Promise<T>,
  timeoutMs = AUTHENTICATION_TIMEOUT_MS,
): Promise<T> =>
  new Promise<T>((resolve, reject) => {
    const timeout = globalThis.setTimeout(
      () => reject(new AuthenticationTimeoutError(timeoutMs)),
      timeoutMs,
    );

    operation.then(
      (value) => {
        globalThis.clearTimeout(timeout);
        resolve(value);
      },
      (error: unknown) => {
        globalThis.clearTimeout(timeout);
        reject(error);
      },
    );
  });
